import { render } from "./FirewallPolicyTab.vue?vue&type=template&id=1a5349d7"
import script from "./FirewallPolicyTab.vue?vue&type=script&lang=js"
export * from "./FirewallPolicyTab.vue?vue&type=script&lang=js"

import exportComponent from "/cloudstack/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__